
// go to hash on page load

$(window).on("load", function () {
  let globalHash = window.location.hash
  if (globalHash) goToHash(globalHash)
})


$('a').click(function(e){
  let url = $(this).attr('href')
  if (url.charAt(0) === '#'){
    e.preventDefault()
    goToHash(url)
    return false
  }
})


export function goToHash (hash) {
  if (hash) {
    hash = hash.replace('#', '')
    hash = hash.replace('/', '')
    let hashEl = $('#' + hash)

    if (hashEl.length) {
      $('html, body').animate({ scrollTop: hashEl.offset().top - 50 })
    }
    lastHistory = ''
    setUrlHash(hash)
  }
}



let lastHistory = '';
let hashTimeout = 0;
export function setUrlHash (hash) {
  if (lastHistory !== hash && !hashTimeout && window.location.hash !== '#'+hash) {
    lastHistory = hash
    if (window.history && window.history.pushState) {
      let curUrl = window.location.href.split(/[?#]/)[0]
      if (hash) hash = '#' + hash
      history.pushState({}, null, curUrl + hash)
      hashTimeout = 1
      setTimeout(function(){hashTimeout = 0}, 300)
    }
  }
}
